import React, { FC } from "react";

import { IConfigurationItem } from "../../common/interfaces/clubs-wizard.interface";
import "./ConfigurationItems.scss";

const ConfigurationItems: FC<{
  configurationItems: IConfigurationItem[];
  activeConfig: IConfigurationItem;
  changeSelectedConfigItem: (item) => void;
}> = (props) => {
  const getClubConfigClassName = (
    item: IConfigurationItem,
    disabled?: boolean
  ) => {
    return `configuration-item__element ${
      props.activeConfig &&
      item.name === props.activeConfig.name &&
      !item.disabled
        ? `configuration-item__element--active`
        : item.disabled && `configuration-item__element--disabled`
    }`;
  };

  return (
    <>
      {props.configurationItems.map((item) => {
        return (
          <div
            onClick={() =>
              !item.disabled && props.changeSelectedConfigItem(item)
            }
            key={item.name}
            className={getClubConfigClassName(item)}
          >
            <div
              className={`configuration-item__icon-wrapper ${
                props.activeConfig &&
                item.name === props.activeConfig.name &&
                `configuration-item__icon-wrapper--active`
              }`}
            >
              <div
                className={`configuration-item__icon-content ${
                  props.activeConfig &&
                  item.name === props.activeConfig.name &&
                  `configuration-item__icon-content--active`
                }`}
              />
            </div>
            <div className="configuration-item__about">
              <div className="configuration-item__header">
                <p className="configuration-item__title">{item.title}</p>
                {/* {item.disabled && (
                  <p className="configuration-item__coming-soon">Coming soon</p>
                )} */}
              </div>
              <p className="configuration-item__description">
                {item.description}
              </p>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default ConfigurationItems;
